// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ac-break-rule-id-container{padding-bottom:1rem}`, "",{"version":3,"sources":["webpack://./src/EmploymentBillboard/Admin/RuleSet/RuleSetEdit/Step3-ScheduleRulesSection/ActualHours.scss"],"names":[],"mappings":"AAAA,4BACI,mBAAA","sourcesContent":[".ac-break-rule-id-container {\r\n    padding-bottom: 1rem;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
